module.exports = __webpack_public_path__ + "static/media/REMAN-SLIDE-0.41a2c503.png";